import RouteView from '../../router/RouteView.vue';
import CourseSummary from './CourseSummary';// 商品汇总
import AuthorityStatistics from './AuthorityStatistics';// 授权统计
import ConsumptionStatistics from './ConsumptionStatistics'; // 耗课统计
import ClassStatistics from './ClassStatistics'; // 上课统计
export default[
  {
    path: '/courseGoods',
    name: 'CourseGoods',
    component: RouteView,
    redirect: '/courseGoods/summary',
    meta: {
      title: '课程商品',
    },
    children: [
      {
        path: '/courseGoods/summary',
        name: 'CourseSummary',
        component: CourseSummary,
        meta: {
          title: '课程列表',
        },
      },
    ],
  },
  {
    path: '/authority',
    name: 'Authority',
    component: RouteView,
    redirect: '/authority/statistics',
    meta: {
      title: '授权统计',
    },
    children: [
      {
        path: '/authority/statistics',
        name: 'AuthorityStatistics',
        component: AuthorityStatistics,
        meta: {
          title: '统计列表',
        },
      },
    ],
  },
  {
    path: '/consumption',
    name: 'Consumption',
    component: RouteView,
    redirect: '/consumption/statistics',
    meta: {
      title: '耗课统计',
    },
    children: [
      {
        path: '/consumption/statistics',
        name: 'ConsumptionStatistics',
        component: ConsumptionStatistics,
        meta: {
          title: '统计列表',
        },
      },
    ],
  },
  {
    path: '/class',
    name: 'Class',
    component: RouteView,
    redirect: '/class/statistics',
    meta: {
      title: '上课统计',
    },
    children: [
      {
        path: '/class/statistics',
        name: 'ClassStatistics',
        component: ClassStatistics,
        meta: {
          title: '统计列表',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/CourseGoods/index.js